// auth.js
const LOGIN_PATH = "/scancam-edge/login";

export const getUserData = () => {
  try {
    const sessionData = localStorage.getItem("userData");
    return sessionData ? JSON.parse(sessionData) : null;
  } catch (err) {
    console.error("[auth] could not parse stored session", err);
    return null;
  }
};

// validTill is the epoch millis returned by sn-auth-service at login. Sessions
// created before this field was read (or perpetual tokens) have no expiry, and
// are treated as valid so we never lock anyone out unexpectedly.
export const getValidTill = () => {
  const userData = getUserData();
  const validTill = userData ? Number(userData.validTill) : NaN;
  return Number.isFinite(validTill) ? validTill : null;
};

export const isSessionValid = () => {
  const userData = getUserData();
  if (!userData || !userData.token) return false;
  if (localStorage.getItem("isLogged") !== "true") return false;
  const validTill = getValidTill();
  return validTill === null || Date.now() < validTill;
};

export const clearSession = () => {
  localStorage.clear();
};

// Drop the stored session and send the operator back to the login screen. Used
// both by the expiry watchdog and by the 401 handling in session.js.
export const forceLogout = (reason) => {
  if (reason) console.warn(`[auth] session ended: ${reason}`);
  clearSession();
  if (window.location.pathname !== LOGIN_PATH) {
    window.location.href = LOGIN_PATH;
  }
};

const userData = getUserData();
const site = userData ? userData.sites[0] : '';
const sites = userData ? userData.sites : [];
const CustID = userData ? userData.custID : '';
const token = userData ? userData.token : '';
const authHeader = `Bearer ${token}`;

// Store the fetched data in an object that can be accessed throughout the application
const userSession = {
    authHeader,
    site,
    sites,
    CustID,
    token
};

export default userSession;
